<template>
  <div>
    <div class="main-ttl container-xl">
      <h2>
        <span>{{ headingTitle }}</span>
        <small>{{ headingDesc }}</small>
      </h2>
    </div>

    <main class="container-xl">
      <div class="primary-area setting-area bg-none-sm">
        <HeaderSetting />

        <div class="outside-ttl-sm">
          <div class="section-ttl list-btn-area">
            <h3>通知アドレス</h3>
            <Button class="btn btn-main" @click="openCreateModal" >
              <Icon :src="icons.SendIcon" alt="複製アイコン" />
              <span>メール追加</span>
            </Button>
          </div>

          <!-- 通知アドレス登録なし --------------------------- -->
          <div v-if="items === null"></div>
          <div
            v-else-if="items.length === 0"
            class="add-item frame-dashed mb-5"
            :class="{
              'animate__animated': true,
              'animate__fadeIn': items.length === 0,
            }"
          >
            <a href="#" class="link-area" @click.prevent="openCreateModal"></a>
            <p>まだ通知アドレスが<span>登録されていません。</span></p>
            <button
              class="btn btn-main"
            ><Icon :src="icons.SendIcon" alt="複製アイコン" />メンバー招待
            </button>
          </div>

          <template v-else
          >
          <ul class="flex list-unstyled small list-head">
            <li class="col-11">メールアドレス</li>
            <li class="col-1 column-ico">削除</li>
          </ul>

          <ul v-if="items.length" class="list-unstyled setting-list pdf-list pb-5"
            :class="{
              'animate__animated': true,
              'animate__fadeIn': items.length > 0,
            }"
          >
            <li class="row" :key="index" v-for="(notificationRecipient, index) in items">
              <div class="col-11">{{ notificationRecipient.email }}</div>
              <div class="col-1 column-ico">
                <a
                  modalId="add-notification-modal"
                  @click="remove(notificationRecipient)"
                >
                  <Icon :src="icons.CrossIcon" alt="削除アイコン" />
                </a>
              </div>
            </li>
          </ul>
          </template>

          <CreateModal
            modalId="create-notification-recipient-modal"
            :service-account-id="currentServiceAccount.serviceAccountId"
            ref="createNotificationRecipientModal"
            @store="registerd"
          />

          <DeleteModal
            modalId="delete-notification-recipient-modal"
            :notificationRecipient="formItems.notificationRecipient"
            ref="deleteNotificationRecipientModal"
            @destroy="removed"
          />
        </div>
      </div>
    </main>

  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { RepositoryFactory } from "repositories/factory";
// import NotificationRecipient from "models/notification-recipient";

import { Button, Icon } from "components";
import { HeaderSetting } from "containers";
import { CrossIcon, SendIcon } from "icons";
import {
  CreateModal,
  DeleteModal,
} from "components/notification-recipients";

import {
  SCREEEN_STATUS_CD,
} from "models/screen-status";

const NotificationRecipientsRepository = RepositoryFactory.get("notification-recipients");

export default {
  name: "NotificationRecipientList",
  components: {
    Button,
    CreateModal,
    DeleteModal,
    HeaderSetting,
    Icon,
  },
  data() {
    return {
      headingTitle: "サービスアカウント設定",
      headingDesc: "サービスアカウントの登録情報です。",
      icons: {
        CrossIcon,
        SendIcon,
      },
      items: null,
      formItems: {
        notificationRecipient: null,
      },
    };
  },
  computed: {
    ...mapGetters({
      /* ログイン情報 */
      userAccount: "profile/userAccount",
      currentServiceAccount: "service-account/currentServiceAccount",
      currentAsigProject: "asig-project/currentAsigProject",
      /* アプリステータス */
      screenStatusCd: "application/screenStatusCd",
      isScreenActive: "application/isScreenActive",
      isScreenLoading: "application/isScreenLoading",
    }),
  },
  async created() {
    /* 初期化処理 */
    try {
      // 監視対象一覧の取得
      this.items = await NotificationRecipientsRepository.index(
        this.currentServiceAccount.serviceAccountId,
      );

      // 画面機能を有効化
      await this.updateScreenStatusCd(SCREEEN_STATUS_CD.ACTIVE);
    } catch (err) {
      console.log(err);
      this.setErrorNotification({
        message: "予期せぬエラーが発生しました。",
      });
    }
  },
  methods: {
    ...mapActions({
      /* 画面ステータス更新 */
      updateScreenStatusCd: "application/updateScreenStatusCd",
      /* 通知制御 */
      resetNotificaton: "notification/resetState",
      setNotification: "notification/setNotification",
      setErrorNotification: "notification/setErrorNotification",
    }),
    async openCreateModal() {
      // メッセージの初期化
      await this.resetNotificaton();
      this.$refs.createNotificationRecipientModal.openModal();
    },
    // リスト更新
    async registerd() {
      this.items = await NotificationRecipientsRepository.index(
        this.currentServiceAccount.serviceAccountId,
      );
    },
    async remove(notificationRecipient) {
      await this.resetNotificaton();
      this.formItems.notificationRecipient = notificationRecipient;
      this.$refs.deleteNotificationRecipientModal.openModal();
    },
    async removed() {
      // リスト更新
      this.items = await NotificationRecipientsRepository.index(
        this.currentServiceAccount.serviceAccountId,
      );
      this.setNotification({
        message: "通知先アドレスを削除しました。",
      });
    },
  },
};
</script>
